module.exports = __webpack_public_path__ + "static/media/wordmark-blue.4cd8d270.svg";